<import from="../../views/attribute-window/attribute-window"></import>
<mdc-dialog-title>
    Attribute Window
</mdc-dialog-title>
<mdc-dialog-content>
    <attribute-window first-level.bind="false"></attribute-window>      
</mdc-dialog-content>
<mdc-dialog-actions>
    <button mdc-button data-mdc-dialog-action="close" click.trigger="close()">Close</button>
</mdc-dialog-actions>